<template>
    <v-progress-linear indeterminate v-if="loading"/>
    <v-app v-else>
        <v-navigation-drawer fixed :clipped="$vuetify.breakpoint.mdAndUp" app v-model="drawer"
                             class="hidden-print-only">
            <v-list>
                <v-list-item :to="{name: 'CustomerIndex'}">
                    <v-list-item-action>
                        <v-icon>people</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            Kunder
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'CarIndex'}">
                    <v-list-item-action>
                        <v-icon>directions_car</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            Biler
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'Invoicing'}">
                    <v-list-item-action>
                        <v-icon>receipt</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            Fakturering
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'LocationSummary'}">
                    <v-list-item-action>
                        <v-icon>view_module</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            Lokasjoner
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'SmsCampaign'}">
                    <v-list-item-action>
                        <v-icon>sms</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            SMS-kampanjer
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'SmsLog'}">
                    <v-list-item-action>
                        <v-icon>speaker_notes</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            SMS-historikk
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'UserIndex'}">
                    <v-list-item-action>
                        <v-icon>account_box</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            Brukere
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-divider/>
            <v-list>
                <v-list-item flat @click="logout">
                    <v-list-item-action>
                        <v-icon>exit_to_app</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            Logg ut {{ $root.user.full_name }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <a href="http://perhagen.no/" target="_blank" class="project-logo">
                <img src="../assets/logo.svg" alt="Per Hagen">
            </a>
        </v-navigation-drawer>
        <v-app-bar color="blue darken-3" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed
                   class="hidden-print-only">
            <v-toolbar-title class="ml-0 app-toolbar-title">
                <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
                <span class="hidden-sm-and-down pl-3">Dekkhotell</span>
            </v-toolbar-title>
            <v-spacer class="hidden-md-and-up"/>
            <search-form/>

            <v-spacer/>

            <v-btn @click="rebootPrinter">
                <v-icon left>print</v-icon>
                Start på nytt
            </v-btn>

            <v-menu v-model="showPrintMenu" :close-on-content-click="false" :nudge-width="200" offset-y
                    v-if="$root.printer">
                <template v-slot:activator="{on}">
                    <v-btn v-on="on" icon>
                        <v-icon>print</v-icon>
                    </v-btn>
                </template>

                <v-card>
                    <v-toolbar flat dense>
                        <v-toolbar-title>
                            Zebra printer
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <ul class="ml-3">
                            <li v-for="(value, key) in $root.printer.device">{{ key }}: {{ value }}</li>
                        </ul>
                    </v-card-text>
                    <v-card-text>
                        <pre>
                            {{ $root.printer.status }}
                        </pre>
                    </v-card-text>
                </v-card>
            </v-menu>
        </v-app-bar>
        <v-content>
            <router-view/>
        </v-content>
    </v-app>
</template>

<script>
import SearchForm from './helpers/SearchForm';

export default {
    components: {
        SearchForm
    },

    data() {
        return {
            drawer: true,
            loading: false,
            showPrintMenu: false
        }
    },

    created() {
        this.loading = true;
        this.$http.get('user').then(response => {
            this.$root.user = response.data.data;

            return this.$http.get('settings').then(response => {
                this.$root.settings = response.data;
            })
        }).finally(() => {
            this.loading = false;
        });
    },

    methods: {
        logout() {
            this.loading = true;
            this.$http.post('logout').then(response => {
                this.$router.push({name: 'Login'});
            }).finally(() => {
                this.loading = false;
            });
        },

        rebootPrinter() {
            let ok = confirm('Vil du kjøre en omstart av dekkprinteren?')
            if (!ok) return;

            this.$http.post('settings/printer/reboot').then(response => {
                this.$root.addMessage('Omstart av printer startet.', 'green');
            }).catch(error => {
                this.$root.addMessage(error.response.data.message, 'red');
            });
        }
    }
}
</script>

<style>
.project-logo {
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    opacity: 0.6;
    transition: opacity 0.5s;
    background: linear-gradient(5deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.0) 40%);
}

.project-logo:hover {
    opacity: 1;
}

.project-logo img {
    padding: 0.75rem 1.2rem;
    max-width: 65%;
}

.filter-container {
    min-height: 60px;
}

.vue-affix.affix {
    background-color: #fff;
    z-index: 2;
    padding: 0.5rem 1rem 0 1rem;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    border-bottom: 2px solid #ddd;
}

.input-capitalize .v-text-field__slot input {
    text-transform: capitalize;
}

@media (min-width: 1024px) {
    .app-toolbar-title {
        width: 240px;
    }
}

@media print {
    @page {
        size: landscape;
        margin: 0.5cm;
    }

    .theme--light.application {
        background-color: #fff !important;
    }

    .v-content {
        padding-top: 0 !important;
        padding-left: 0 !important;
    }

    table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
        padding: 0 12px !important;
    }
}
</style>
